export default async ({ router }) => {
  const routeData = {
    path: '/',
    component: () => import('src/modules/auth/layouts/PlainLayout.vue')
  }
  routeData.children = [
    {
      name: 'statics:404',
      path: ':pathMatch(.*)*',
      component: () => import('src/pages/Error404')
    }
  ]

  router.addRoute(routeData)
}
